import { aggregatedPackagesListSchema, aggregatedRepositoriesListSchema, agentCommandEventsListSchema, agentCommandEventsStatsSchema, agentCommandFilterOptionsQuerySchema, agentCommandFilterOptionsResponseSchema, listAggregatedPackagesParamsSchema, listAggregatedRepositoriesParamsSchema, listAgentCommandEventsParamsSchema, } from '../contracts/agent-command-events';
import { organizationIdSchema, } from '../contracts/organizations';
import { serializeTableQueryParams } from '../contracts/table';
import { parseSchema } from '../errors';
/**
 * Typed client helpers for the "Agents Activity → Packages & Repos" read APIs
 * (KIR-3483). List + summary stats, org-scoped and personal-account variants.
 * List params (incl. per-column `filters`) serialize to bracket-notation query
 * params via serializeTableQueryParams — the shared DataTable convention.
 */
/** List package/git command events for an organization (one tab per call). */
export async function listOrganizationAgentCommandEvents(client, organizationId, params) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const validatedParams = parseSchema(listAgentCommandEventsParamsSchema, params);
    const response = await client.get(`/organizations/${validatedId}/agent-command-events`, { params: validatedParams, paramsSerializer: serializeTableQueryParams });
    return parseSchema(agentCommandEventsListSchema, response);
}
/** Summary stat cards for an organization. */
export async function getOrganizationAgentCommandEventsStats(client, organizationId) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const response = await client.get(`/organizations/${validatedId}/agent-command-events/stats`);
    return parseSchema(agentCommandEventsStatsSchema, response);
}
/** List the current user's own package/git command events (personal view). */
export async function listAccountAgentCommandEvents(client, params) {
    const validatedParams = parseSchema(listAgentCommandEventsParamsSchema, params);
    const response = await client.get('/account/agent-command-events', {
        params: validatedParams,
        paramsSerializer: serializeTableQueryParams,
    });
    return parseSchema(agentCommandEventsListSchema, response);
}
/** Summary stat cards for the current user (personal view). */
export async function getAccountAgentCommandEventsStats(client) {
    const response = await client.get('/account/agent-command-events/stats');
    return parseSchema(agentCommandEventsStatsSchema, response);
}
/** Distinct-value dropdown options for a column filter (organization). */
export async function getOrganizationAgentCommandFilterOptions(client, organizationId, params) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const validatedParams = parseSchema(agentCommandFilterOptionsQuerySchema, params);
    const response = await client.get(`/organizations/${validatedId}/agent-command-events/filter-options`, { params: validatedParams });
    return parseSchema(agentCommandFilterOptionsResponseSchema, response);
}
/** Distinct-value dropdown options for a column filter (personal). */
export async function getAccountAgentCommandFilterOptions(client, params) {
    const validatedParams = parseSchema(agentCommandFilterOptionsQuerySchema, params);
    const response = await client.get('/account/agent-command-events/filter-options', { params: validatedParams });
    return parseSchema(agentCommandFilterOptionsResponseSchema, response);
}
/**
 * List the aggregated Packages view for an organization (KIR-3807): one row per
 * package+source+project+version, with occurrence/user counts and OSV vulns.
 */
export async function listOrganizationAggregatedPackages(client, organizationId, params) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const validatedParams = parseSchema(listAggregatedPackagesParamsSchema, params);
    const response = await client.get(`/organizations/${validatedId}/agent-command-events/packages`, { params: validatedParams, paramsSerializer: serializeTableQueryParams });
    return parseSchema(aggregatedPackagesListSchema, response);
}
/** List the current user's aggregated Packages view (personal). */
export async function listAccountAggregatedPackages(client, params) {
    const validatedParams = parseSchema(listAggregatedPackagesParamsSchema, params);
    const response = await client.get('/account/agent-command-events/packages', {
        params: validatedParams,
        paramsSerializer: serializeTableQueryParams,
    });
    return parseSchema(aggregatedPackagesListSchema, response);
}
/** List the aggregated Repositories view for an organization (KIR-3807). */
export async function listOrganizationAggregatedRepositories(client, organizationId, params) {
    const validatedId = parseSchema(organizationIdSchema, organizationId);
    const validatedParams = parseSchema(listAggregatedRepositoriesParamsSchema, params);
    const response = await client.get(`/organizations/${validatedId}/agent-command-events/repositories`, { params: validatedParams, paramsSerializer: serializeTableQueryParams });
    return parseSchema(aggregatedRepositoriesListSchema, response);
}
/** List the current user's aggregated Repositories view (personal). */
export async function listAccountAggregatedRepositories(client, params) {
    const validatedParams = parseSchema(listAggregatedRepositoriesParamsSchema, params);
    const response = await client.get('/account/agent-command-events/repositories', { params: validatedParams, paramsSerializer: serializeTableQueryParams });
    return parseSchema(aggregatedRepositoriesListSchema, response);
}
//# sourceMappingURL=agent-command-events.js.map